var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
var OperationStatus = /* @__PURE__ */ ((OperationStatus2) => {
  OperationStatus2[OperationStatus2["Admin Portal"] = 0] = "Admin Portal";
  OperationStatus2[OperationStatus2["Analyst Support"] = 1] = "Analyst Support";
  OperationStatus2[OperationStatus2["Control Tower, Experiments, and ExpAPI"] = 2] = "Control Tower, Experiments, and ExpAPI";
  OperationStatus2[OperationStatus2["Metrics"] = 3] = "Metrics";
  OperationStatus2[OperationStatus2["Scorecard Compute"] = 4] = "Scorecard Compute";
  OperationStatus2[OperationStatus2["Treatment Assignment"] = 5] = "Treatment Assignment";
  OperationStatus2[OperationStatus2["xCard"] = 6] = "xCard";
  return OperationStatus2;
})(OperationStatus || {});
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.helpStudio.match.path);
    __publicField(this, "_modulePathname", ROUTES.helpStudio.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`,
        /**
         * Used to get values from local storage for file a ticket form
         * @param payload
         * @returns
         */
        getSourceUrl: (payload) => {
          var url = `${this.url}`;
          url = NavigationService.addParamToPath({
            url,
            param: "source",
            value: `${payload.source}`
          });
          return url;
        },
        getURLWithQueryParams: (payload) => {
          var url = `${this.url}?Issue=${payload.issue}&Category=${OperationStatus[payload.category]}&Description=${payload.description}`;
          if (payload.hideHelpLinks !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "hideHelpLinks",
              value: `${payload.hideHelpLinks}`
            });
          }
          return url;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const HelpRoute = new Util();
export {
  HelpRoute,
  OperationStatus
};
//# sourceMappingURL=HelpRoute.utils.js.map
